import React from 'react';
import { useField } from 'formik';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';

export const UnboundField: React.FC<any> = (props: any) => {
  const [field] = useField(props);

  return <TextBoxComponent value={field.value} enabled={false} {...props} />;
};
